import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getOtp, resetOtpPage } from "../../actions/auth-action";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import "./ForgetPass.scss";
import Header from "../common/HeaderGuest";
import Footer from "../common/Footer";
import HeaderGuest from "../common/HeaderGuest";
import GuestContainer from "./GuestContainer";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";

const ForgetPass = (props) => {
  const { getOtp, resetOtpPage } = props;
  const {t} = useTranslation()

  const [email, setEmail] = useState("");

  const { getOtpStart, getOtpSuccess, getOtpError } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();

  useEffect(() => {
    if (getOtpSuccess) {
      setTimeout(() => {
        history.push("/reset-pass");
      }, 300);
    }
  }, [getOtpSuccess]);

  useEffect(() => {
    resetOtpPage();
    return () => {
      resetOtpPage();
    };
  }, []);

  const clickGetOtp = (e) => {
    e.preventDefault();
    getOtp(email);
  };

  return (
    <>
      
      <GuestContainer>
      <div className="login-content-wrapper">
          <div className="login-content resetPassword-content">
          
              <Link to="/"><img src="/images/named-logo.png"  className="mb-3 auth-logo"></img></Link>
              <h4 >Reset Password</h4>
              <Form className="mt-5 text-center">
              <div className="pos-relative m-0-auto w-80">
                <img src="/images/icon-email.svg" className="input-icon"/>
                  <input
                    type="email"
                    placeholder="Input your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-text"
                  />
                </div>
                <Button
                  type="submit"
                  variant="success"
                  onClick={clickGetOtp}
                  className="blue-btn mt-4"
                >
                  {getOtpStart ? "Sending..." : "Get OTP"}
                </Button>
                <Alert
                  show={getOtpSuccess || getOtpError != null}
                  variant={getOtpError ? "danger" : "success"}
                  className="mt-3"
                >
                  {" "}
                  {getOtpError || "Otp has been sent!"}
                </Alert>
              </Form>
            
           
            
              
          </div>
          <div className="login-content-bottom-link">
					<ul>
						<li>Back to <Link to="/login" className="link-text">{t("login")}</Link></li>
					</ul>
				</div>
        </div>
      </GuestContainer>
    </>
  );
};
export default connect(null, { getOtp, resetOtpPage })(ForgetPass);
